import React, { useState, useEffect, useMemo } from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";
import FirstStep from "./firstStep";
import SecondStep from "./secondStep";
import ThirdStep from "./thirdStep";

import "./styles.css";

import { ReactComponent as WhiteLogoSVG } from "../../assets/logo/M_WHITE_LOGO_SQUARE.svg";

import {
  Snackbar,
  Typography,
  CircularProgress,
  Modal,
  Button,
  Box,
  IconButton,
  Tooltip,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import HelpIcon from "@mui/icons-material/Help";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { ReactComponent as Logo } from "../../assets/logo/DARK_LOGO.svg";

export default function SignIn() {
  document.title = "Cadastro | Ginastee";

  const [currentStep, setCurrentStep] = useState(1);

  const [accountType, setAccountType] = useState(null);

  function handleStepChange(details) {
    setCurrentStep(details.goTo);
  }

  const ControlHeader = ({ title, current }) => {
    return (
      <div
        className="mb-4 current-step-signin px-1 py-1"
        style={{ display: "flex", alignItems: "center" }}
      >
        {current !== 1 && (
          <IconButton
            className="button-return"
            size="small"
            color="primary"
            onClick={() => handleStepChange({ current, goTo: current - 1 })}
          >
            <ArrowBackIosIcon color="primary" />
          </IconButton>
        )}
        <Typography variant="label" component="label">
          {title}
        </Typography>
      </div>
    );
  };
 
  return (
    <div className="page">
      <Logo className="header-logo" />

      <>
        <Typography variant="h1" component="h1" className="center mt-4">
          Cadastrar novo desafio
        </Typography>
        <Typography variant="h4" component="h4" className="mt-2 center">
          Sua comunidade estará pronta em alguns instantes
        </Typography>
      </>

      <div className="form-area px-4 pb-5 pt-3 mt-3">
        {
          {
            1: (
              <ControlHeader
                current={1}
                title="Primeiro passo: Email e senha"
              />
            ),
            2: (
              <ControlHeader
                current={2}
                title="Segundo passo: Suas informações"
              />
            ),
          }[currentStep]
        }
        {
          {
            1: <FirstStep dispatchChangeStep={handleStepChange} />,
            2: <SecondStep dispatchChangeStep={handleStepChange} />,
          }[currentStep]
        }
      </div>
    </div>
  );
}
